<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   payment: {
    type: [Object, null],
    required: true
   }
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="p-3">
        <table class="table table-bordered table-sm table-light">
            <tbody v-if="props.payment">
                <tr>
                    <th colspan="2" class="text-center">Payment</th>
                </tr>
                <tr>
                    <td class="text-center">OR No.</td>
                    <td class="text-center">{{ props.payment.or_number ? props.payment.or_number : 'n/a' }}</td>
                </tr>
                <tr>
                   <td class="text-center">Amount</td>
                   <td class="text-center">{{ props.payment.amount ? props.payment.amount.toLocaleString() : 'n/a' }}</td>
                </tr>
                <tr>
                   <td class="text-center">Payment Date</td>
                   <td class="text-center">{{ props.payment.payment_date ? props.payment.payment_date : 'n/a' }}</td>
                </tr>
                <tr>
                   <td class="text-center">Remarks</td>
                   <td class="text-center">{{ props.payment.remarks ? props.payment.remarks : 'n/a' }}</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <th colspan="2" class="text-center">Payment</th>
                </tr>
                <tr>
                    <td class="text-center">OR No.</td>
                    <td class="text-center">n/a</td>
                </tr>
                <tr>
                   <td class="text-center">Amount</td>
                   <td class="text-center">n/a</td>
                </tr>
                <tr>
                   <td class="text-center">Payment Date</td>
                   <td class="text-center">n/a</td>
                </tr>
                <tr>
                   <td class="text-center">Remarks</td>
                   <td class="text-center">n/a</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
